import localization from './i18n';

export const MESSAGE_1 = localization.messages.en.api_error;
export const MESSAGE_2 = localization.messages.en.page_error;



// WEBPACK FOOTER //
// src/utils/error-messages.js